const selectFriendChange = 'selectFriendChange'
const logout = 'logout'
const chatLogListChange = 'chatLogListChange'
const chatLogListNomore = 'chatLogListNomore'
const sysCfgInitSuccess = 'sysCfgInitSuccess'
//发送好友消息
const sendFriendMsg = 'sendFriendMsg'

//预发送好友消息
const preSendFriendMsg = 'preSendFriendMsg'

//加载账号更多好友
const loadMoreAccountFriend = "load_more_account_friend"
//好友配置信息变更
const accontConfigChange = "accontConfigChange"
//播放语音消息
const play_audio_msg = "play_audio_msg"
//空号检测变更
const contact_check_change = 'contact_check_change'

//消息命令
export default {
    selectFriendChange,
    logout,
    sysCfgInitSuccess,
    chatLogListChange,
    chatLogListNomore,
    sendFriendMsg,
    loadMoreAccountFriend,
    accontConfigChange,
    play_audio_msg,
    preSendFriendMsg,
    contact_check_change,
}